import { useMutation } from '@tanstack/react-query';
import { getCookie, setCookieMinutes } from './cookieUtils';
import { createUrl } from 'src/core/api/utils/createUrl';
import { fetch as fetchRedirect } from './refetch';

const ID_HASH = 'id_hash';

export interface IdHashValidationResponse {
  success: boolean;
  status?: string|number;
  data: any;
}

/**
 * Get id_hash from Url query parameters
 */
export const getIdHashFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(ID_HASH);
}

/**
 * Get id_hash from cookie
 * @returns id_hash value or null
 */
export const getIdHashFromCookie = (): string | null => {
  return getCookie(ID_HASH);
};


/**
 * Save id_hash from URL query parameters to cookie
 */
export const saveIdHashFromUrl = (): void => {
  const idHash = getIdHashFromUrl();

  if (idHash) {
    setCookieMinutes(ID_HASH, idHash, 5);
  }
};

/**
 * Plain async function for validating id_hash with backend API.
 * Not a hook — safe to call anywhere.
 */
export const validateIdHash = async (idHash: string): Promise<any> => {
  const response = await fetchRedirect(createUrl('/override'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ id_hash: idHash }),
  });

  return response.body as IdHashValidationResponse;
};

/**
 * React hook wrapping validateIdHash with useMutation.
 * Use this inside components or other hooks.
 */
export const useValidateIdHash = () => {
  return useMutation<IdHashValidationResponse, Error, string>({
    mutationFn: validateIdHash,
  });
};

